// Cart size upgrade: add the larger size, then remove the smaller one, then refresh the cart drawer.
(function () {
  var json = { 'Content-Type': 'application/json', Accept: 'application/json' };
  document.addEventListener('click', async function (e) {
    var b = e.target.closest('[data-pa-upgrade]');
    if (!b) return;
    e.preventDefault();
    if (b.disabled) return;
    b.disabled = true;
    b.classList.add('is-loading');
    try {
      var add = await fetch('/cart/add.js', { method: 'POST', headers: json, body: JSON.stringify({ items: [{ id: +b.dataset.variant, quantity: +b.dataset.qty || 1 }] }) });
      if (!add.ok) throw new Error('add failed');
      await fetch('/cart/change.js', { method: 'POST', headers: json, body: JSON.stringify({ id: b.dataset.key, quantity: 0 }) });
      if (location.pathname.indexOf('/cart') === 0 || !document.querySelector('cart-drawer')) { location.reload(); return; }
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { open: true } }));
    } catch (err) {
      b.disabled = false;
      b.classList.remove('is-loading');
      b.querySelector('span').textContent = 'Kunne ikke opgradere – prøv igen';
    }
  });
})();
